import PathoRiskNoStarsText from './PathoRiskNoStarsText';
import MendelianNoStarsCard from './Mendelian/MendelianNoStarsCard';
import ComplexNoStarsCard from './Complex/ComplexNoStarsCard';
import SectionStructure from '../../../../../components/Section/SectionStructure';
import Grid from '@mui/material/Grid';


export default function SectionPathoRiskNoStars() {

    
    return (

    <SectionStructure
    
    sectiontext=    { <PathoRiskNoStarsText /> }

    sectioncards=  {<>
        
     <Grid container>
        <Grid size={{xs:12, xl:6 }} sx={{display:'flex', justifyContent:'center', alignItems: 'flex-start' }}> <MendelianNoStarsCard />  </Grid> 
        <Grid size={{xs:12, xl:6 }} sx={{display:'flex', justifyContent:'center', alignItems: 'flex-start' }}> <ComplexNoStarsCard /> </Grid> 
    </Grid> 
        </>}
    />
)
}